export function isSheetPractice(practice) {
    return 'sheet' in practice;
}
export function isMetronomePractice(practice) {
    return 'signature' in practice;
}
//# sourceMappingURL=Practice.js.map